import { render, staticRenderFns } from "./UploadSingleFile.vue?vue&type=template&id=804a8bec"
import script from "./UploadSingleFile.vue?vue&type=script&lang=js"
export * from "./UploadSingleFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports